/* This file is automatically generated, do not edit manually! */

/* eslint-disable */

exports.WM_INDEX = {
  '@': [
    '.*T5555!',
    '.*T8585!',
    '.*S521!',
    '.*T33(20|33|35)!',
    '.*T5353!',
    '.*P3700!',
    '.*T82(82|83)!',
    '.*T73(73|80)!',
    '.*T7272!',
    '.*T2223!'
  ],
  '@-G': ['-GalaxyII', '-GalaxyMini'],
  '@-P': ['-P525!', '-P526!', '-P527!', '-P552w!', '-P552!', '-P565!', '-P735!'],
  '@12': [1210],
  '@A3': ['A3100', 'A3300c'],
  '@A4': ['A4500!'],
  '@AL': ['Alltel HTC PPC6800', 'Alltel HTC Touch', 'Alltel HTC Touch Diamond'],
  '@AM': ['Ameo!'],
  '@BI': ['Bird T900'],
  '@C6': ['C6625'],
  '@CH': ['CHT 9100!'],
  '@CO': ['Coolpad F800'],
  '@DA': ['Datalogic Memor'],
  '@DO': ['Dopod838Pro', 'DopodD810', 'dopod-S900c', 'dopodT5588', 'dopodT8388', 'dopodT8588'],
  '@DX': ['DX900'],
  '@E1': ['E100'],
  '@ES': ['ES405B!'],
  '@F9': ['F900'],
  '@GA': ['garmin-asus-Nuvifone-M10'],
  '@GI': ['GIGABYTE-MS800'],
  '@GM': ['GM730', 'GM750Q'],
  '@GT': [
    'GT-B5722',
    'GT-B6520',
    'GT-B7300',
    'GT-B7320!',
    'GT-B7330!',
    'GT-B7350',
    'GT-B7610',
    'GT-C6625',
    'GT-I8000!'
  ],
  '@GW': ['GW550', 'GW825'],
  '@H-': ['H-21'],
  '@HD': ['(HTC )?HD mini!', '(HTC )?HD2!'],
  '@HP': [
    'HP iPAQ 510',
    'HPiPAQ510!',
    'HPiPAQ610',
    'HPiPAQ910!',
    'HP iPAQ h6300',
    'HP iPAQ hw6500!',
    'HPiPAQhw6900!',
    'HPiPAQrw6800!',
    'HPiPAQrw6815!',
    'HPiPAQDataMessenger!',
    'HPiPAQVoiceMessenger!',
    'HPiPAQGlisten',
    'HP KB1'
  ],
  '@HT': [
    'HTC8500',
    'HTC P3300',
    'HTC love',
    'HTC P3350',
    'HTC P3400!',
    'HTC P3450!',
    'HTC HERALD',
    'HTC P6300',
    'HTC P6500',
    'HTC X7500',
    'HTC X7510',
    '(HTC )?HD mini!',
    '(HTC )?HD2!',
    'HTC T8290',
    'HTC MAX 4G',
    'HTC MTeoR',
    'HTC Prophet',
    'HTC Snap!',
    'HTC Maple S520',
    'HTC S620!',
    'HTC Excalibur',
    'HTC S630',
    'HTC S710',
    'HTC S730',
    'HTC S740',
    'HTC Touch',
    'HTC Elf',
    'HTC 6900',
    'HTC6900',
    'HTC6900-MR1',
    'HTC TouchDual',
    'HTC Touch 3G!',
    'HTC Jade',
    'HTC Mega!',
    'HTC Touch2!',
    'HTC Touch Cruise!',
    'HTC P3650',
    'HTC P3651',
    'HTC Polaris',
    'HTC Touch Diamond2!',
    'HTC Touch Diamond!',
    'HTC Diamond',
    'HTC P3701',
    'HTC P5500',
    'HTC P5310!',
    'HTC Touch HD2!',
    'HTC Touch HD!',
    'HTC Touch Pro2!',
    'HTC Touch Pro!',
    'HTC P4600',
    'HTC Raphael',
    'HTC Touch Viva!',
    'HTC Trinity',
    'HTC P3600',
    'HTC P3600i',
    'HTC v3600',
    'HTC TyTN II',
    'HTC Kaiser',
    'HTC TyTN!',
    'HTC Mercury',
    'HTC wizard',
    'HTCPPC6850!',
    'HTC VDA V',
    'HTC v1510',
    'HTC VPACompactIV',
    'HT01A'
  ],
  '@I-': [
    'i-mate JAMA',
    'i-mate JAMAQ',
    'i-mate JAMin',
    'i-mate JASJAM',
    'i-mate JAQ',
    'i-mate JAQ3',
    'i-mate K-JAM',
    'i-mate PDAL',
    'i-mate 6150',
    'i-mate 8150!',
    'i-mate 8502',
    'i-mate 9502!'
  ],
  '@K-': ['K-Touch W366!'],
  '@KD': ['KDDI-HT01'],
  '@KY': ['Kyocera-E4000'],
  '@LE': ['Lenovo ET860', 'LENOVO-ET980'],
  '@LG': ['LG-GM730!', 'LG-GM750!', 'LG-GW550!', 'LG-KS20', 'LG-MS25', 'LGE VS750'],
  '@M1': ['M1i'],
  '@M5': ['M530w!'],
  '@M9': ['M930!'],
  '@MC': ['MC45!', 'MC659B!'],
  '@MD': ['MDA III!', 'MDA compact II!', 'MDA compact!', 'MDA Pro!', 'MDA Touch!', 'MDA Vario!'],
  '@NU': ['Nuvifone-M10', 'Nuvifone-M20'],
  '@O2': ['o2 Xda comet', 'O2 Xda 2mini', 'O2 Xda 2s'],
  '@P3': ['P3470!', 'P3450', 'P3650', 'P3650t', 'P3600!'],
  '@P4': ['P400', 'P4350!', 'P4550'],
  '@P5': ['P550'],
  '@P7': ['P750'],
  '@PA': ['Palm500!', 'Palm750', 'Palm850!', 'Palm Treo850e', 'PANTECH-C810'],
  '@PP': ['PPC6850!'],
  '@Q-': ['Q-UMTS'],
  '@Q8': ['Q8'],
  '@Q9': ['Q9', 'Q9c!', 'Q9m!'],
  '@S0': ['S01SH', 'S01SH2'],
  '@S1': ['S11HT', 'S12HT'],
  '@S2': ['S200', 'S21HT', 'S22HT'],
  '@SC': [
    'SCH-M490',
    'SCH-M710',
    'SCH-M715',
    'SCH-i220!',
    'SCH-i225!',
    'SCH-i760!',
    'SCH-i770!',
    'SCHI910!',
    'SCH-i920',
    'SC-01B'
  ],
  '@SF': ['SFR v3650!'],
  '@SG': [
    'SGH-i600!',
    'SGH-i601!',
    'SGH-I607',
    'SGH-i608!',
    'SGH-I617',
    'SGH-I637',
    'SGH-i640!',
    'SGH-i718',
    'SGH-i718plus',
    'SGH-i728',
    'SGH-i780!',
    'SGH-i900!',
    'SGH-i908E'
  ],
  '@SI': ['SIE-SX66', 'sigmarion3'],
  '@SP': [
    'Sprint:MotoQ9c',
    'Sprint Treo850e',
    'SPH-M7200',
    'SPH-M7350',
    'SPH-M8400',
    'SPHI325!',
    'Spice D1100',
    'SPV E600',
    'SPV E650',
    'SPV M700',
    'SPV M2000',
    'SPV M3100',
    'Sprint S511',
    'Sprint:SPH-ip830w',
    'Sprint:PPC6600-1',
    'Sprint:PPC-6700',
    'Sprint:PPC6800',
    'Sprint PPC6850SP',
    'Sprint MP6850SP',
    'Sprint MP6900SP',
    'Sprint MP6950SP'
  ],
  '@T-': ['T-Mobile Atlas', 'T-Mobile Dash', 'T-Mobile LEO', 'T-Mobile Cleopatra', 'T-01A!', 'T-01B!'],
  '@T5': ['T5388'],
  '@T9': ['T9188', 'T9199'],
  '@TG': ['(Toshiba[- ])?TG01!'],
  '@TO': ['(Toshiba[- ])?TG01!'],
  '@TR': ['Treo800w'],
  '@V1': ['v1415', 'v1240', 'v1210', 'v1640'],
  '@VE': ['Velocity'],
  '@VI': ['VIP12!'],
  '@VP': ['VPA Touch'],
  '@W3': ['W366'],
  '@WS': ['WS003SH', 'WS004SH', 'WS007SH', 'WS011SH', 'WS020SH', 'WS027SH'],
  '@X0': ['X01T', 'X02T!', 'X01HT', 'X02HT', 'X03HT', 'X04HT', 'X05HT', 'X01SC'],
  '@X1': ['X1', 'X1[ia]!'],
  '@X2': ['X2', 'X2[ia]!'],
  '@XD': ['Xda diamond', 'Xda neo', 'Xda nova', 'Xda orbit', 'Xda terra', 'Xda trion'],
  '@XV': ['XV6175!', 'XV6850!', 'XV6875!', 'XV6900', 'XV6975'],
  '@ZT': ['ZTE E N72', 'ZTE E X70']
};

/* This file is automatically generated, do not edit manually! */
